const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Crear registro de entrega o recolección
 */
export const createEntregaCliente = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al crear registro');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en createEntregaCliente:', error);
    throw error;
  }
};

/**
 * Obtener registros con filtros y paginación
 */
export const fetchEntregasClientes = async (filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 20, sort } = filters;
    const body = { query, page, limit };
    if (sort) body.sort = sort;
    const response = await fetch(`${API_URL}/entregas-clientes/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error('Error al obtener registros');
    const result = await response.json();
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error en fetchEntregasClientes:', error);
    throw error;
  }
};

/**
 * Obtener registro por ID
 */
export const fetchEntregaClienteById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al obtener registro');
    return await response.json();
  } catch (error) {
    console.error('Error en fetchEntregaClienteById:', error);
    throw error;
  }
};

/**
 * Buscar por consecutivo
 */
export const fetchEntregaByConsecutivo = async (consecutivo) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/consecutivo/${consecutivo}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al buscar por consecutivo');
    return await response.json();
  } catch (error) {
    console.error('Error en fetchEntregaByConsecutivo:', error);
    throw error;
  }
};

/**
 * Obtener registros por cliente
 */
export const fetchEntregasByCliente = async (clienteId, tipo, limit = 20, page = 1) => {
  try {
    let url = `${API_URL}/entregas-clientes/cliente/${clienteId}?limit=${limit}&page=${page}`;
    if (tipo) url += `&tipo=${tipo}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al obtener registros del cliente');
    const result = await response.json();
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error en fetchEntregasByCliente:', error);
    throw error;
  }
};

/**
 * Marcar entregas como "En Camino" (batch)
 */
export const marcarEnCamino = async (ids, conductor) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/marcar-en-camino`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids, conductor }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al marcar en camino');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en marcarEnCamino:', error);
    throw error;
  }
};

/**
 * Reasignar conductor a entregas
 */
export const reasignarConductor = async (ids, conductor) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/reasignar-conductor`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids, conductor }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al reasignar conductor');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en reasignarConductor:', error);
    throw error;
  }
};

/**
 * Confirmar entrega al cliente
 */
export const confirmarEntrega = async (id, items, recibe, observaciones) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/confirmar-entrega/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, recibe, observaciones }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al confirmar entrega');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en confirmarEntrega:', error);
    throw error;
  }
};

/**
 * Registrar hora de llegada de ropa sucia
 */
export const registrarLlegada = async (consecutivo, id, totalBolsas) => {
  try {
    const body = { consecutivo };
    if (id) body.id = id;
    if (totalBolsas != null) body.totalBolsas = totalBolsas;
    const response = await fetch(`${API_URL}/entregas-clientes/registrar-llegada`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al registrar llegada');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en registrarLlegada:', error);
    throw error;
  }
};

/**
 * Verificar recolección de ropa sucia
 */
export const verificarRecoleccion = async (id, items, verificado_por, observacion_verificacion) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/verificar/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, verificado_por, observacion_verificacion }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al verificar recolección');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en verificarRecoleccion:', error);
    throw error;
  }
};

/**
 * Actualizar items y observaciones de una recolección/entrega
 */
export const updateEntregaCliente = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/update/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al actualizar');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en updateEntregaCliente:', error);
    throw error;
  }
};

/**
 * Modificar cantidades por admin con trazabilidad completa.
 * @param {string} id - ID del registro
 * @param {Array} items - Items con cantidades corregidas
 * @param {{ id: string, nombre: string }} admin - Admin que realiza la modificación
 * @param {string} motivo - Razón de la modificación
 */
export const modificarCantidadesAdmin = async (id, items, admin, motivo) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/admin-modificar/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, admin, motivo }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al modificar cantidades');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en modificarCantidadesAdmin:', error);
    throw error;
  }
};

/**
 * Cancelar entrega/recolección
 */
export const cancelarEntrega = async (id, observaciones) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/cancelar/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ observaciones }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al cancelar');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en cancelarEntrega:', error);
    throw error;
  }
};
